import { v4 as uuidV4 } from 'uuid';

export const v4 = uuidV4;
